export default __webpack_public_path__ + "static/media/chris.44bdcf47.jpeg";